import { isProtectedRoute } from '@client/trpc/sessionHandling';
import { isVersionCheckExcludedPath } from './version-constants';

export function shouldEnableAppBuildVersionForRoute({
    accessToken,
    pathname,
}: {
    accessToken: string | undefined;
    pathname: string;
}): boolean {
    if (isVersionCheckExcludedPath(pathname)) {
        return false;
    }

    return !isProtectedRoute(pathname) || Boolean(accessToken);
}
